import isEmpty from "lodash.isempty";
import mergeWith from "lodash.mergewith";

import apiInstance from "../../../services/api";
import apiProxy from "../../../services/apiProxy";
import getFilters from "../getFilters/getFilters";
import normalizeFilters from "../normalizeFilters";

const customizer = (objValue, srcValue) => {
  if (objValue !== undefined) {
    return `${objValue},${srcValue}`;
  }
  return undefined;
};

const fetchVacancies = async (
  queryToParse,
  locale,
  predefinedFilters,
  tenantIdList,
  additionalFilters,
  limit = 5000,
  start = 0,
  isInternal = false,
  order = "DESC"
) => {
  const queryFilters = await getFilters(queryToParse, locale);

  const query = mergeWith(
    {},
    queryFilters,
    normalizeFilters(predefinedFilters),
    !isEmpty(tenantIdList) ? { tenantIds: tenantIdList } : {},
    additionalFilters,
    { start },
    customizer,
    { isInternal },
    { order }
  );

  const options = {
    fields: [
      "id",
      "category",
      "company",
      "description",
      "hoursType",
      "jobTitle",
      "location",
      "remuneration",
      "applicationUrl",
      "validFrom",
      "validTo",
    ],
    limit,
  };
  const api = !isEmpty(tenantIdList) ? apiProxy : apiInstance;

  return api
    .getVacancies(query, options)
    .then((data) => data)
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log("FetchVacancies error ->", error);
      return [];
    });
};

export default fetchVacancies;
